import React, { useEffect, useState } from 'react'
import { Hamburger, HeaderCloseIcon, RightArrow, SiteLogo } from '../../icons/index'

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    
  };
  useEffect(() => {
    if(mobileMenuOpen){
      document.body.style.overflow = "hidden";
    }else{
      document.body.style.overflow = "auto";
    }
  },[mobileMenuOpen])

  return (
    <header className='max-w-[1042px] mx-auto p-4 overflow-hidden flex items-center justify-between'>
      <div className="md:w-[172px] w-[132px]">
        <a href="https://collegenroll.com/" target="_blank" rel="noreferrer" aria-label="CollegEnroll"><SiteLogo className="w-full h-[22px] md:h-[29px]" /></a>
      </div>
      <nav className='hidden desktop-header'>
        <ul className=" flex-col h-full md:h-auto bg-white md:bg-transparent md:flex-row flex items-center justify-between gap-x-8 ">
          <li className=" relative font-lexendlight text-sm leading-[23px] text-dark-500 font-light"><a href="https://collegenroll.com/degree-courses/">Degree Courses</a></li>
          <li className=" relative font-lexendlight text-sm leading-[23px] text-dark-500 font-light"><a href="https://collegenroll.com/bootcamps-courses/">Bootcamps</a></li>
          <li className=" relative font-lexendlight text-sm leading-[23px] text-dark-500 font-light"><a href="https://collegenroll.com/the-classroom/">Blog</a></li>
          <li className=" relative font-lexendlight text-sm leading-[23px] text-dark-500 font-light"><a href="https://collegenroll.com/about-us/">About Us</a></li>
        </ul>
      </nav>
      <button aria-label='Menu' className="hidden items-center justify-center focus:outline-none" onClick={toggleMobileMenu}>
        {< Hamburger />}
      </button>
      <div className={`fixed bg-white top-0 left-0 w-full h-full md:hidden z-[99999] transition-transform ${mobileMenuOpen ? "translate-x-0" : "translate-x-full"}`}>
        <div className="bg-[#f8f8f8] flex justify-between py-7 px-5 pb-[10px] border-b-[1px] border-b-light-600">
          <div>
            <a href="https://collegenroll.com" aria-label="CollegEnroll" target="_blank" rel="noreferrer">
              {<SiteLogo />}
            </a>
          </div>
          <div onClick={toggleMobileMenu} className='w-4 h-6 overflow-hidden cursor-pointer'>
            <HeaderCloseIcon/>
          </div>
        </div>
        <nav className='hidden'>
          <ul>
            <li className='mt-[5px]'>
              <a className='flex items-center justify-between px-7 py-4 border-b-[1px] border-b-light-600 font-lexendlight text-sm leading-[23px] text-dark-500 font-light' href="https://collegenroll.com/degree-courses/">Degree Courses <RightArrow /></a>
            </li>
            <li className='mt-[5px]'>
              <a className='flex items-center justify-between px-7 py-4 border-b-[1px] border-b-light-600 font-lexendlight text-sm leading-[23px] text-dark-500 font-light' href="https://collegenroll.com/bootcamps-courses/">Bootcamps <RightArrow /></a>
            </li>
            <li className='mt-[5px]'>
              <a className='flex items-center justify-between px-7 py-4 border-b-[1px] border-b-light-600 font-lexendlight text-sm leading-[23px] text-dark-500 font-light' href="https://collegenroll.com/the-classroom/">Blog <RightArrow /></a>
            </li>
            <li className='mt-[5px]'>
              <a className='flex items-center justify-between px-7 py-4 border-b-[1px] border-b-light-600 font-lexendlight text-sm leading-[23px] text-dark-500 font-light' href="https://collegenroll.com/about-us/">About Us <RightArrow /></a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  )
}

export default Header